<template>
  <v-list-item
    :to="route"
    class="pa-0 ma-0"
    active-class="primary--text font-weight-bold"
  >
    <v-list-item>
      <v-list-item-action v-if="icon">
        <v-badge
          v-if="badge"
          color="red"
          dot
          overlap
          offset-x="8"
          offset-y="8"
        >
          <v-icon>{{ icon }}</v-icon>
        </v-badge>
        <v-icon v-else>{{ icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-title>
        {{ title }}
        <v-chip
          v-if="badge"
          x-small
          color="red"
          text-color="white"
          class="ml-2"
        >{{ $t('NEW') }}</v-chip>
      </v-list-item-title>
    </v-list-item>
  </v-list-item>
</template>

<script>
  export default {
    name: 'NavItem',
    props: {
      route: [Object, String],
      icon: String,
      title: String,
      badge: { type: Boolean, default: false },
    },
  };
</script>

<style scoped>

</style>
